import AuthService from './authService.js'

const formatDateOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'long',
  day:'numeric',
  hour:'numeric',
  minute:'numeric',
  second:'numeric'
}


//TODO: Make a folder and separate utilities
const Utils = {
  generic_request: async (request) => {
    // console.log('Auth: '  + AuthService.isAuthenticated())
    try {
      let response = await request()
      return response
    } catch (error) {
      if (error.status !== undefined && error.status === 401) {
        // console.log('Hay que refrescar el token')
        await AuthService.refreshToken()
        // console.log('Token refrescado correctamente')
        return request()
      } else {
        throw(error)
      }
    }
  },

  getTimeDifference (eventTimestamp) {
    var then = new Date(eventTimestamp)
    var now = new Date()
    var difference = Math.trunc(Math.abs((now.getTime() - then.getTime()) / 1000))

    var hours = Math.trunc(difference / 3600)
    var minutes = Math.trunc((difference % 3600) / 60)
    var seconds = Math.trunc((difference % 3600) % 60)

    return `${hours} hora(s) ${minutes} minuto(s) ${seconds} segundo(s)`
  },

  formatDatetime (datetime) {
    return new Date(datetime).toLocaleDateString('es-ES', formatDateOptions)
  }
}

export default Utils



// WEBPACK FOOTER //
// ./src/utils.js